import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { ProduccionForm } from "./components/ProduccionForm";
import "./styles/CreacionProduccion.css";

class CreacionProduccion extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="produccion_activo"
                    titulo="Nueva Producción"
                    subtitulo=""
                    col="12"
                >
                    <ProduccionForm regresar={this.regresar} />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(CreacionProduccion);
